import { Routes } from '@angular/router';
import { AuthGuard } from '@web/birdz-angular';
import { PageDashboardMapComponent } from 'app/components/page-dashboard-map/page-dashboard-map.component';
import { PageDashboardSummaryComponent } from 'app/components/page-dashboard-summary/page-dashboard-summary.component';
import { PageDashboardComponent } from 'app/components/page-dashboard/page-dashboard.component';
import { PageKpiDetailsComponent } from 'app/components/page-kpi-details/page-kpi-details.component';
import { PageKpiMapComponent } from 'app/components/page-kpi-map/page-kpi-map.component';
import { PageKpiSummaryComponent } from 'app/components/page-kpi-summary/page-kpi-summary.component';
import { PageKpiComponent } from 'app/components/page-kpi/page-kpi.component';
import { RedirectComponent } from 'app/components/redirect/redirect.component';

export const routes: Routes = [
  {
    path: '',
    canActivateChild: [AuthGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        component: PageDashboardComponent,
        children: [
          { path: '', component: RedirectComponent },
          {
            path: 'summary',
            component: PageDashboardSummaryComponent,
            data: { reuseRoute: true },
          },
          {
            path: 'map',
            component: PageDashboardMapComponent,
            data: { reuseRoute: true },
          },
        ],
      },
      {
        path: 'kpis',
        component: PageKpiComponent,
        children: [
          { path: '', component: RedirectComponent },
          {
            path: 'summary',
            component: PageKpiSummaryComponent,
            data: { reuseRoute: true },
          },
          {
            path: 'details',
            component: PageKpiDetailsComponent,
            data: { reuseRoute: true },
          },
          {
            path: 'map',
            component: PageKpiMapComponent,
            data: { reuseRoute: true },
          },
        ],
      },
      { path: '**', redirectTo: 'dashboard', pathMatch: 'full' },
    ],
  },
];
